import { AxiosError } from 'axios';

export enum ErrorCode {
    InternalServerError = 'INTERNAL_SERVER_ERROR',
    Unauthorized = 'UNAUTHORIZED',
    Forbidden = 'FORBIDDEN',
    NotFound = 'NOT_FOUND',
    BadRequest = 'BAD_REQUEST',
    InvalidDocumentOwner = 'INVALID_DOCUMENT_OWNER',
    DocumentNotFound = 'DOCUMENT_NOT_FOUND',
    SignRecordNotFound = 'SIGN_RECORD_NOT_FOUND',
    LinkConfirmationNotTeliaPhoneNumber = 'LINK_CONFIRMATION_NOT_TELIA_PHONE_NUMBER',
    LinkConfirmationPrePaidSubscriptionEzys = 'LINK_CONFIRMATION_PRE_PAID_SUBSCRIPTION_EZYS',
    LinkConfirmationPrePaidSubscriptionEXTRA = 'LINK_CONFIRMATION_PRE_PAID_SUBSCRIPTION_EXTRA',
    LinkConfirmationNotActiveSubscription = 'LINK_CONFIRMATION_NOT_ACTIVE_SUBSCRIPTION',
    LinkConfirmationBlockedDueToLostSim = 'LINK_CONFIRMATION_BLOCKED_DUE_TO_LOST_SIM',
    LinkConfirmationBlockedDueToLimitExceeded = 'LINK_CONFIRMATION_BLOCKED_DUE_TO_LIMIT_EXCEEDED',
    LinkConfirmationBlockedDueToUnpaid = 'LINK_CONFIRMATION_BLOCKED_DUE_TO_UNPAID',
    LinkConfirmationCodeInvalid = 'LINK_CONFIRMATION_CODE_INVALID',
    LinkConfirmationOwnerIsNotAbleLinkSubscription = 'LINK_CONFIRMATION_OWNER_IS_NOT_ABLE_LINK_SUBSCRIPTION',
    LinkConfirmationSecondaryESimOwner = 'LINK_CONFIRMATION_SECONDARY_ESIM_OWNER',
    LinkConfirmationSecondaryESimNotOwner = 'LINK_CONFIRMATION_SECONDARY_ESIM_NOT_OWNER',
    DocumentGenerationRequestLimitExceeded = 'REQUEST_LIMIT_EXCEEDED',
    DocumentGenerationRequestAlreadyExists = 'REQUEST_ALREADY_EXISTS',
    AgreementLimitReached = 'AGREEMENT_LIMIT_REACHED',
    ServiceUnavailable = 'SERVICE_UNAVAILABLE',
    CartOrderInProgress = 'CART_ORDER_IN_PROGRESS',
    CartSubscriptionChargeLimitExceeded = 'CART_SUBSCRIPTION_CHARGE_LIMIT_EXCEEDED',
    CartSubscriptionUnpaid = 'CART_SUBSCRIPTION_UNPAID',
    CartSubscriptionBlockedByCustomer = 'CART_SUBSCRIPTION_BLOCKED_BY_CUSTOMER',
    CartSubscriptionSuspended = 'CART_SUBSCRIPTION_SUSPENDED',
    CartSubscriptionSimCardLocking = 'CART_SUBSCRIPTION_SIM_CARD_LOCKING',
    CartSubscriptionSimCardUnlocking = 'CART_SUBSCRIPTION_SIM_CARD_UNLOCKING',
    CartBillsOverdue = 'CART_BILLS_OVERDUE',
    CallbackAlreadyExists = 'CALLBACK_ALREADY_EXISTS',
    CartContactPhoneMissing = 'CART_CONTACT_PHONE_MISSING',
    LinkConfirmationBlockedServiceType = 'LINK_CONFIRMATION_BLOCKED_SERVICE_TYPE',
}

export type ErrorModelMS = {
    code: ErrorCode;
    message: string;
    timestamp: string;
};

export type CommonAxiosError = AxiosError<ErrorModelMS>;
